import { Injectable } from "@angular/core";
import { API_URL } from "common/constants/sm-constants";
import { CompanyMentorModel } from "common/models/page-models/internship-company/company-mentor/company-mentor-data.model";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { DataService } from "../../base-data-services/data.service";

@Injectable()
export class MentorDeleteDataService extends DataService<CompanyMentorModel> {
  constructor(protected ss: SystemService, protected http: SmApiService) {
    super(ss, API_URL.internshipCompanyMentorDelete, http);
  }

  //    override getAPI_URL(): API_URL {
  //         return API_URL.getDocumentTypeList;
  //       }

  createInstance(): CompanyMentorModel {
    return new CompanyMentorModel();
  }
}